import React from "react";
import Link from "next/link";
import { getIcon } from "@litonarefin/utils/icons";
import { getStyledIcon } from "@litonarefin/utils/getStyledIcon";
import { cn } from "@litonarefin/utils";

const BreadcrumbList = ({ name, slug = "", position, icon = "arrow", last = false }) => {
  return (
    <li>
      <Link
        prefetch={false}
        href={last ? "#" : slug}
        className={cn(
          "jlt-flex jlt-items-center jlt-gap-1",
          last ? "jlt-cursor-default jlt-pointer-events-none" : ""
        )}
      >
        {icon === "arrow"
          ? getStyledIcon(getIcon("arrowRightAlt"), "#98A2B3", undefined, {
              width: "8px",
              height: "8px",
            })
          : getStyledIcon(getIcon("home"), "#98A2B3", "stroke", {width: "18px"})}
        <span
          className={cn(
            "jlt-text-[8px] md:jlt-text-[10px] jlt-font-medium jlt-text-[#667085] hover:jlt-text-[--primary] hover:jlt-underline"
          )}
          dangerouslySetInnerHTML={{ __html: name }}
        />
      </Link>
    </li>
  );
};

export default BreadcrumbList;
